<template>
</template>

<script>
import orderMutations from "../../../store/web/order/mutation-types";
export default {
  props: ['order'],
  mounted() {
    this.$store.commit('order/' + orderMutations.SET_ORDER, this.order);
    window.Echo.channel(`${window.wistro.base.name}.order.${this.order.uuid}`)
      .listen('OrderUpdatedPublicEvent', (e) => {
        this.$store.commit('order/' + orderMutations.SET_ORDER, e.order);
    });
  }
}
</script>

<style>
</style>
